import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import '@/assets/css/reset.css'

import '@/styles/quill.core.css';
import '@/styles/quill.snow.css';
import '@/styles/quill.bubble.css';
// import vant from '@/components/vantComponents'
import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
